import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import Button, { TYPES } from '../Button/index'
import { connect as connectStaticText } from '../StaticText/connect'
import GaiaLogo from '../GaiaLogo/index'
import { isNonAmazonAndroid, isAmazon } from '../../environment/index'
import { URL_APPLE_APP_STORE, URL_ANDROID_APP_STORE, URL_AMAZON_APP_STORE_FIRE_TABLET } from '../../services/url/constants'
import { H3, HEADING_TYPES } from '../Heading/index'

function buildDeepLink (id) {
  return `gaia://play-video/${id}`
}

function handleSkipDownloadClick (props) {
  return (e) => {
    e.stopPropagation()
    e.preventDefault()
    const { onSkipDownloadClick } = props

    if (onSkipDownloadClick) {
      onSkipDownloadClick()
    }
  }
}

function handleDeepLinkClick () {
  return (e) => {
    // kill browser link handling
    e.stopPropagation()
    e.preventDefault()

    const { target } = e
    const { href } = target

    // most cross-browser compatible method of redirect
    setTimeout(() => {
      global.location = href
    }, 500)
  }
}

function handleDownloadAppClick (props) {
  return (e) => {
    // kill browser link handling
    e.stopPropagation()
    e.preventDefault()

    const { target } = e
    const { href } = target
    const { onDownloadAppClick } = props

    if (onDownloadAppClick) {
      onDownloadAppClick()
    }

    // most cross-browser compatible method of redirect
    setTimeout(() => {
      global.location = href
    }, 500)
  }
}

class DownloadAppModal extends Component {
  render () {
    const { video, staticText } = this.props
    const poster = video.getIn(['data', 'poster'])
    const id = video.get('id', null)
    let appStoreUrl = URL_APPLE_APP_STORE
    if (isNonAmazonAndroid()) {
      appStoreUrl = URL_ANDROID_APP_STORE
    } else if (isAmazon()) {
      appStoreUrl = URL_AMAZON_APP_STORE_FIRE_TABLET
    }

    return (
      <div className="download-app">
        <div className="download-app__skip-cta-wrapper">
          <Button
            type={TYPES.LINK}
            onClick={handleSkipDownloadClick(this.props)}
            className="download-app__skip-link"
          >
            {staticText.getIn(['data', 'skipCtaText'])}
          </Button>
        </div>

        <div className="download-app__content">
          <div className="download-app__logo-wrapper">
            <GaiaLogo className={['download-app__logo']} type="white" />
          </div>
          <div className="download-app__play-wrapper">
            <H3 as={HEADING_TYPES.H4} className="download-app__play-header">{staticText.getIn(['data', 'headingText'])}</H3>
            {poster ? (
              <div className="download-app__poster-wrapper">
                <a
                  onClick={handleDeepLinkClick(this.props)}
                  className="button download-app__play-app-cta-btn"
                  href={buildDeepLink(id)}
                >{staticText.getIn(['data', 'playInAppCtaText'])}</a>
                <img src={poster} className="download-app__poster" alt="" />
              </div>
            ) : (
              <a
                onClick={handleDeepLinkClick(this.props)}
                className="button download-app__play-app-cta-btn download-app__play-app-cta-btn--no-poster"
                href={buildDeepLink(id)}
              >{staticText.getIn(['data', 'playInAppCtaText'])}</a>
            )}
          </div>

          <div className="download-app__download-wrapper">
            <H3 as={HEADING_TYPES.H4} className="download-app__download-header">
              {staticText.getIn(['data', 'downloadAppCtaText'])}
            </H3>
            <a
              onClick={handleDownloadAppClick(this.props)}
              className="button download-app__download-cta-btn"
              href={appStoreUrl}
            >{staticText.getIn(['data', 'appCtaText'])}</a>
          </div>
        </div>
      </div>
    )
  }
}

DownloadAppModal.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  onDownloadAppClick: PropTypes.func,
  onSkipDownloadClick: PropTypes.func,
  onWatchOnAppClick: PropTypes.func,
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  video: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'downloadAppModal' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
    }),
  ),
)(DownloadAppModal)
